import { AttachmentService } from 'src/app/services/attachment.service';
import { VehicleImagesModel } from './../../../models/Vehicle/VehicleImagesModel';
import { SearchService } from 'src/app/services/search.service';
import { element } from 'protractor';
import { ImageService } from './../../../services/image.service';
import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { Vehicle } from 'src/app/models/Vehicle';
import { AttachmentScopesEnum, AttachmentTypeEnum } from 'src/app/models/enums/Attachment/AttachmentEnum';
@Component({
  selector: 'image-gallery',
  templateUrl: './image-gallery.component.html',
  styleUrls: ['./image-gallery.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ImageGalleryComponent implements OnInit {
  images = [];
  slideIndex = 0;
  vehicle: Vehicle;
  faTimesCircle = faTimesCircle;
  vehicleImagesModel: VehicleImagesModel[];

  constructor(
    private imageService: ImageService,
    private searchService: SearchService,
    private attachmentService: AttachmentService
  ) {



    this.images = imageService.images;

  }

  ngOnInit() {

    this.imageService.vehicle.subscribe(res => {
      this.vehicle = res;

      if (res != null) {
        this.searchService.getVehicleGalleryByVehicleID(res.vehicleID).subscribe(res => {
          if (res != null && res.length > 0) {
            this.vehicleImagesModel = res;
            if(document.getElementById('imgModal')!=null){
              document.getElementById('imgModal').style.display = "block";
            }

          }
          else {
            this.imageService.updateVehicleImage(null);
            if(document.getElementById('imgModal')!=null){
              document.getElementById('imgModal').style.display = "none";
            }

          }
        })
      }
      else{
        this.vehicleImagesModel=null;
      }


    });

  }

  @ViewChild('imageContent') set imageContent(element) {
    if (element) {
      // here you get access only when element is rendered (or destroyed)
      this.currentSlide(0 + 1);
    }
  }

  get attachmentScopesEnum() {
    return AttachmentScopesEnum;
  }
  get attachmentTypeEnum() {
    return AttachmentTypeEnum;
  }
  loadImages(): void {
    this.imageService.fetchImages()
      .subscribe(images => this.images = images);
  }
  openModal() {
    document.getElementById('imgModal').style.display = "block";
  }
  closeModal() {
    this.imageService.updateVehicleImage(null);
    document.getElementById('imgModal').style.display = "none";
  }
  plusSlides(n) {
    this.showSlides(this.slideIndex += n);
  }
  currentSlide(n) {
    this.showSlides(this.slideIndex = n);
  }
  showSlides(slideIndex);
  showSlides(n) {
    let i;
    const slides = document.getElementsByClassName("img-slides") as HTMLCollectionOf<HTMLElement>;
    const dots = document.getElementsByClassName("images") as HTMLCollectionOf<HTMLElement>;
    if (n > slides.length) {
      this.slideIndex = 1
    }
    if (n < 1) {
      this.slideIndex = slides.length
    }
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(" active", "");
    }
    slides[this.slideIndex - 1].style.display = "block";
    if (dots && dots.length > 0) {
      dots[this.slideIndex - 1].className += " active";
    }
  }

}

